<div class="overlay" (click)="closeModal()"></div>
<div class="modal-content-wrapper">
  <header class="popup-header">
    <div class="popup-header__brand">
      <span class="popup-header__icon" aria-hidden="true">
        <i class="pi pi-map"></i>
      </span>
      <div class="popup-header__title-wrap">
        <span class="popup-title">OGC Feature Collection</span>
        @if (hasApiResponse && features.length > 0) {
          <span class="popup-header__count">{{ features.length }} feature{{ features.length !== 1 ? 's' : '' }}</span>
        }
      </div>
    </div>
    <button
      type="button"
      class="popup-close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <img
        src="/icons/close-x.svg"
        width="16"
        height="16"
        alt=""
        aria-hidden="true"
      />
    </button>
  </header>

  <div class="map-sidebar-layout">
    <!-- Map Container -->
    <div class="map-container">
      <div #featureMap id="feature-map" class="feature-map" aria-label="Map for selecting bounding box"></div>
    </div>

    <!-- Right Sidebar: Feature Properties (when marker clicked) or Bounding box card -->
    <aside class="map-sidebar">
      @if (selectedFeature) {
        <div class="bbox-card bbox-card--alt2 bbox-card--combined">
          <div class="bbox-card__header-alt">
            <i class="pi pi-list"></i>
            <span>Feature Properties</span>
            <button
              type="button"
              class="properties-close-btn"
              aria-label="Back to bounding box"
              (click)="closePropertiesPanel()"
            >
              <img
                src="/icons/close-x.svg"
                width="16"
                height="16"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
          <div class="bbox-card__body">
            <div class="properties-content">
              <div class="properties-list">
                @for (entry of getPropertyEntries(); track entry.key) {
                  <div class="property-row" [class.property-row--null]="entry.type === 'null'">
                    <span class="property-row__key">{{ entry.key }}</span>
                    <span class="property-row__value">
                      @switch (entry.type) {
                        @case ('email') {
                          <a [href]="'mailto:' + entry.value" class="property-link" target="_blank" rel="noopener">{{ entry.value }}</a>
                        }
                        @case ('link') {
                          <a [href]="entry.value" class="property-link" target="_blank" rel="noopener">{{ entry.value }}</a>
                        }
                        @default {
                          {{ formatPropertyValue(entry.value) }}
                        }
                      }
                    </span>
                  </div>
                }
              </div>
              <button type="button" class="properties-copy-btn" [class.copied]="copiedToClipboard" (click)="copyPropertiesJson()">
                @if (copiedToClipboard) {
                  <i class="pi pi-check"></i>
                  <span>Copied!</span>
                } @else {
                  <i class="pi pi-copy"></i>
                  <span>Copy raw JSON</span>
                }
              </button>
            </div>
          </div>
        </div>
      } @else if (selectedBbox || (hasApiResponse && features.length > 0)) {
        <div class="bbox-card bbox-card--alt2 bbox-card--combined">
          <div class="bbox-card__header-alt">
            <i class="pi pi-box"></i>
            <span>Selected Bounding Box</span>
          </div>
          <div class="bbox-card__body">
            @if (selectedBbox) {
              <div class="bbox-coords-row">
                <div class="bbox-coord">
                  <span class="bbox-coord__label">East</span>
                  <span class="bbox-coord__value">{{ selectedBbox.east.toFixed(6) }}</span>
                </div>
                <div class="bbox-coord">
                  <span class="bbox-coord__label">West</span>
                  <span class="bbox-coord__value">{{ selectedBbox.west.toFixed(6) }}</span>
                </div>
                <div class="bbox-coord">
                  <span class="bbox-coord__label">North</span>
                  <span class="bbox-coord__value">{{ selectedBbox.north.toFixed(6) }}</span>
                </div>
                <div class="bbox-coord">
                  <span class="bbox-coord__label">South</span>
                  <span class="bbox-coord__value">{{ selectedBbox.south.toFixed(6) }}</span>
                </div>
              </div>
              <div class="bbox-array-wrap">
                <span class="bbox-array__label">BBOX Array</span>
                <code class="bbox-array__value">[{{ formatBboxArray() }}]</code>
              </div>
            }
            @if (isApplying) {
              <div class="bbox-loading">
                <span class="action-btn__spinner" aria-hidden="true"></span>
                <span>Fetching features...</span>
              </div>
            }
            @if (selectedBbox && (hasApiResponse && features.length === 0) && !applyError) {
              <div class="bbox-no-data">
                <i class="pi pi-info-circle"></i>
                <p>No features found in this area.</p>
                <button type="button" class="action-btn action-btn--primary" (click)="resetAndShowToolbar()">
                  <i class="pi pi-draw-polygon"></i>
                  <span>Draw new area</span>
                </button>
              </div>
            }
            @if (selectedBbox && applyError) {
              <div class="bbox-no-data">
                <p>Try selecting a different area.</p>
                <button type="button" class="action-btn action-btn--primary" (click)="resetAndShowToolbar()">
                  <i class="pi pi-draw-polygon"></i>
                  <span>Draw new area</span>
                </button>
              </div>
            }
            @if (selectedBbox && (hasApiResponse && features.length > 0)) {
              <div class="bbox-card__status-row">
                <div class="bbox-card__actions">
                  <button type="button" class="action-btn action-btn--secondary" (click)="resetAndShowToolbar()">
                    <i class="pi pi-refresh"></i>
                    <span>Reset</span>
                  </button>
                  <button type="button" class="action-btn action-btn--primary" (click)="downloadFeatures()">
                    <i class="pi pi-download"></i>
                    <span>Download</span>
                  </button>
                </div>
              </div>
            }
            @if (selectedBbox && !hasApiResponse && !applyError && !isApplying) {
              <div class="bbox-card__status-row">
                <div class="bbox-card__actions">
                  <button type="button" class="action-btn action-btn--secondary" (click)="resetAndShowToolbar()">
                    <i class="pi pi-refresh"></i>
                    <span>Reset</span>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="bbox-card bbox-card--alt2 bbox-card--placeholder">
          <div class="bbox-card__header-alt">
            <i class="pi pi-box"></i>
            <span>Select Area</span>
          </div>
          <div class="bbox-card__body">
            <div class="select-area">
              <div class="select-area__intro">
                <h3 class="select-area__title">Choose a drawing tool</h3>
                <p class="select-area__desc">Select an option below, then draw on the map to define your area. Features will load automatically when you finish.</p>
              </div>
              <div class="draw-tools">
                <span class="draw-tools__label">Drawing tools</span>
                <div class="draw-tools__grid">
                  <button
                    type="button"
                    class="draw-tool-btn"
                    [class.active]="activeDrawMode === 'polygon'"
                    (click)="startDrawPolygon()"
                    title="Draw a custom polygon shape"
                  >
                    <span class="draw-tool-btn__icon">
                      <i class="pi pi-draw-polygon"></i>
                    </span>
                    <span class="draw-tool-btn__content">
                      <span class="draw-tool-btn__label">Polygon</span>
                      <span class="draw-tool-btn__hint">Custom shape</span>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="draw-tool-btn"
                    [class.active]="activeDrawMode === 'rectangle'"
                    (click)="startDrawRectangle()"
                    title="Draw a rectangular area"
                  >
                    <span class="draw-tool-btn__icon">
                      <i class="pi pi-stop"></i>
                    </span>
                    <span class="draw-tool-btn__content">
                      <span class="draw-tool-btn__label">Rectangle</span>
                      <span class="draw-tool-btn__hint">Box area</span>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="draw-tool-btn"
                    [class.active]="activeDrawMode === 'circle'"
                    (click)="startDrawCircle()"
                    title="Draw a circular area"
                  >
                    <span class="draw-tool-btn__icon">
                      <i class="pi pi-circle"></i>
                    </span>
                    <span class="draw-tool-btn__content">
                      <span class="draw-tool-btn__label">Circle</span>
                      <span class="draw-tool-btn__hint">Radius from center</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (applyError) {
        <div class="error-banner">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ applyError }}</span>
        </div>
      }
    </aside>
  </div>
</div>
